import React from 'react';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { Reference } from '../types/email';
interface ReferenceTagProps {
  reference: Reference;
}
const typeColors = {
  company: {
    bg: '#e3f2fd',
    text: '#1976d2',
    border: '#90caf9'
  },
  case: {
    bg: '#f3e5f5',
    text: '#7b1fa2',
    border: '#ce93d8'
  },
  enquiry: {
    bg: '#fff3e0',
    text: '#e65100',
    border: '#ffb74d'
  },
  transaction: {
    bg: '#e8f5e9',
    text: '#2e7d32',
    border: '#81c784'
  }
};
const typeLabels = {
  company: 'Company',
  case: 'Case',
  enquiry: 'Enquiry',
  transaction: 'Transaction'
};
export function ReferenceTag({
  reference
}: ReferenceTagProps) {
  const colors = typeColors[reference.type];
  return <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded text-xs font-medium border" style={{
    backgroundColor: colors.bg,
    color: colors.text,
    borderColor: colors.border
  }} data-id="element-91">
      {reference.found ? <CheckCircle2 className="w-3 h-3" data-id="element-92" /> : <AlertCircle className="w-3 h-3" data-id="element-93" />}
      <span className="text-[10px] uppercase tracking-wide opacity-70" data-id="element-94">
        {typeLabels[reference.type]}
      </span>
      <span className="font-mono font-semibold" data-id="element-95">{reference.number}</span>
    </span>;
}